<template>
  <div class="c-loader-logo">
    <div ref="logo" class="c-loader-logo__logo"></div>
  </div>
</template>

<script>
import lottie from "lottie-web";
export default {
  data() {
    return {
      logoAnimation: null,
      autoplay: false,
      timeout: null
    };
  },
  mounted() {
    this.setAnimation();
  },
  methods: {
    setAnimation() {
      // Destroy autoplaynimation if exists
      if (this.logoAnimation) {
        this.logoAnimation.destroy();
      }

      this.logoAnimation = lottie.loadAnimation({
        container: this.$refs.logo,
        renderer: "svg",
        autoplay: false,
        loop: false,
        animationData: require(`assets/animations/${this.$root.$i18n.locale}/logo.json`)
      });
      this.timeout = setTimeout(() => {
        this.startAnimation();
      }, 500);
    },
    startAnimation() {
      this.logoAnimation.play();
      clearTimeout(this.timeout);
    }
  }
};
</script>

<style lang="scss">
.c-loader-logo {
  display: flex;
  width: 100%;
  height: 100%;
  justify-content: center;
  align-items: center;
  padding: var(--grid-gutter);
  &__logo {
    max-width: 800px;
    width: 100%;
    height: 100%;
    svg {
      path {
        fill: $color-white;
      }
    }
  }
}
</style>
